import { Tooltip as ReactTooltip } from "react-tooltip";
import { useMemo } from "@wordpress/element";
import { v4 as uuid } from "uuid";

type Props = {
    title: string;
    render: (props: Record<string, string>) => React.ReactElement;
};

export function Tooltip({ title, render }: Props) {
    const id = useMemo(() => uuid(), []);

    return (
        <>
            <ReactTooltip id={id} />
            {render({
                "data-tooltip-id": id,
                "data-tooltip-content": title,
            })}
        </>
    );
}
